import React from 'react';

import { ArticleFooter } from '../loadableComponents';

export const useRenderArticleFooterCallback = () => () => <ArticleFooter />;
